var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.412,
    height: 24.412,
    viewBox: "0 0 24.412 24.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M12.206,0A12.206,12.206,0,1,0,24.412,12.206,12.206,12.206,0,0,0,12.206,0Zm2.541,18.917q-.942.372-1.5.566a3.966,3.966,0,0,1-1.3.2,2.6,2.6,0,0,1-1.774-.557,1.8,1.8,0,0,1-.631-1.413,5.131,5.131,0,0,1,.046-.681c.032-.231.083-.492.152-.784l.786-2.778c.069-.267.129-.52.177-.755a3.349,3.349,0,0,0,.07-.654,1.007,1.007,0,0,0-.219-.741,1.244,1.244,0,0,0-.84-.208,2.2,2.2,0,0,0-.625.093c-.212.065-.4.124-.547.182l.208-.856q.772-.315,1.478-.538a4.365,4.365,0,0,1,1.333-.225,2.551,2.551,0,0,1,1.748.548,1.82,1.82,0,0,1,.614,1.422q0,.181-.042.638a4.266,4.266,0,0,1-.157.838l-.782,2.769c-.064.222-.121.476-.173.761a4.022,4.022,0,0,0-.075.647.929.929,0,0,0,.247.752,1.382,1.382,0,0,0,.855.2,2.479,2.479,0,0,0,.647-.1,3.678,3.678,0,0,0,.523-.176Zm-.138-11.24a1.867,1.867,0,0,1-1.317.508,1.886,1.886,0,0,1-1.323-.508,1.623,1.623,0,0,1-.551-1.233,1.639,1.639,0,0,1,.551-1.236,1.873,1.873,0,0,1,1.323-.514,1.852,1.852,0,0,1,1.317.514,1.665,1.665,0,0,1,0,2.469Z",
    transform: "translate(0 0)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.38b7b0f9e374ed47b2437cf49c9ef827.svg";
export { ForwardRef as ReactComponent };